<template>
<div style="width: 100%;height: 100%;background-color: white;">
  <!-- 群聊列表 -->
  <div class="left-list">
    <div class="search-top">
      <div class="rec-search">
        <i class="el-icon-search" style="margin: 9px"></i>
        <input class="input" style="width: calc(100% - 50px);color: #a5b5c1"
               v-model="searchKeyword"/>
      </div>
      <div class="cir-btn-add" @click="openAddEdit()"><i class="el-icon-plus"></i> </div>
    </div>
    <div class="contact-list">
      <div class="list-item" @click="openChat(item)" v-for="item in tbdata" :key="item.index" @contextmenu.stop.prevent="$refs.ctxshow.showMenu($event, item)">
        <div class="head-portrait">
          <el-badge v-if="item === 1" :value="1" class="item">
            <el-avatar style="width: 50px;height: 50px" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
          </el-badge>
          <el-avatar v-else style="width: 50px;height: 50px" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
        </div>
        <div class="msg-contact">
          <div class="name-top"><span>{{ item.name }}</span></div>
          <div class="voice-bottom"><span v-if="item === 1" style="color: #f35d5d">[语音消息]</span><span v-else>[语音消息]</span></div>
        </div>
<!--        <div class="msg-time"><span>昨天 10:00</span></div>-->
      </div>
      <e-vue-contextmenu ref="ctxshow" id="contextStyle" @ctx-show="show" @ctx-hide="hide">
        <div style="height: 40px;line-height:40px;cursor: pointer;border-bottom: 1px solid #cccccc" @click="updateGroupChat"><span style="margin-left: 15px">修改群聊</span></div>
        <div style="height: 40px;line-height:40px;cursor: pointer;" @click="delGroupChat"><span style="margin-left: 15px">删除群聊</span></div>
      </e-vue-contextmenu>
    </div>
  </div>
  <!-- 群聊页面 -->
  <div class="center-list">
    <div class="title-top">
      <div class="title-edit">
        <span>{{ selectGroupMsg.name ? selectGroupMsg.name : '' }}</span> <i @click="editGroupMsg()" style="cursor: pointer" class="el-icon-edit-outline"></i>
<!--        <i @click="getMattData({aa: ''})" style="cursor: pointer" class="el-icon-edit-outline"></i>-->
      </div>
      <div class="user-add-right">
        <img style="width: 28px;cursor: pointer" src="../../assets/tel/addUser.png" @click="addGroupMember()">
      </div>
    </div>
    <div class="window-center" @scroll="scrollInfo()" ref="msgBox">
      <div ref="msgData">
        <div v-for="(item, index) in  groupmsgs" :key="item.index">
          <!-- 群聊 左边 -->
          <div v-if="item.msg_type === 0" style="height: 20px;line-height:34px;margin-left: 20px;font-size: 14px;color: #1a1a1a"><span>{{ item.member_name }}</span></div>
          <div v-if="item.msg_type === 0" class="chat-item">
            <div class="img-left">
              <el-avatar style="width: 50px;height: 50px" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
            </div>
            <div class="voice-right" @click="playRecordItem(item, index,item.isRecordType)">
              <div style="width: calc(100% - 20px)" class="left-voice-content">
<!--                <img style="width: 14px" src="../../assets/tel/voice_left.png">&nbsp;&nbsp;&nbsp;60"-->
                <img v-if="item.isGif" style="width: 14px" src="../../assets/tel/voice_left_gif.gif">
                <img v-else style="width: 14px" src="../../assets/tel/voice_left.png">
                <audio :src="base + item.msg_url" :ref="'mp3Item'+index" />
              </div>
            </div>
          </div>
          <!-- 平台 右边 -->
          <div v-else class="chat-item">
            <div class="img-left1">
              <el-avatar style="width: 50px;height: 50px" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            </div>
            <div class="voice-right1" @click="playRecordItem(item, index,item.isRecordType)">
              <div style="width: calc(100% - 20px)" class="right-voice-content">
                <audio :src="base + item.msg_url" :ref="'mp3Item'+index" />
                <img v-if="item.isGif" style="width: 14px" src="../../assets/tel/voice_right_gif.gif">
                <img v-else style="width: 14px" src="../../assets/tel/voice_right.png">
              </div>
              <!--            <div class="no-read" style="float: right;margin-right: 3px"></div>-->
            </div>
          </div>
          <div style="height: 20px">
            <div class="time-show" v-if="item.msg_type === 0" style="margin-left: 80px;margin-top: -5px"><span>{{ item.msg_tm }}</span></div>
            <div class="time-show" v-else style="margin-right: 80px;float: right;margin-top: -5px"><span>{{ item.msg_tm }}</span></div>
          </div>
        </div>
      </div>
<!--      <div class="time-show"><span>10:00</span></div>-->
    </div>
    <div class="msg-send">
      <div class="area-text">
        <input style="width: 100%;" class="input" placeholder="请在此输入文字" v-model="sendWord"/>
      </div>
      <div class="send-btn-chat" @click="sendVoiceMsg()"><span>转语音发送</span></div>
    </div>
  </div>
  <!-- 群聊成员 -->
  <div class="right-msg">
    <div class="list-item1" v-for="item in msggroupmember" :key="item.index" @contextmenu.stop.prevent="$refs.ctxshow1.showMenu($event, item)">
      <div class="head-portrait">
        <el-badge v-if="item === 1" :value="1" class="item">
          <el-avatar style="width: 50px;height: 50px" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
        </el-badge>
        <el-avatar v-else style="width: 50px;height: 50px" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
      </div>
      <div class="msg-contact">
        <div class="name-top1"><span>{{ item.member_name }}</span></div>
      </div>
    </div>
    <e-vue-contextmenu ref="ctxshow1" id="contextStyle" @ctx-show="show1" @ctx-hide="hide1">
      <div style="height: 40px;line-height:40px;cursor: pointer;border-bottom: 1px solid #cccccc" @click="updateGroupMember"><span style="margin-left: 15px">修改成员</span></div>
      <div style="height: 40px;line-height:40px;cursor: pointer;" @click="delGroupMember"><span style="margin-left: 15px">删除成员</span></div>
    </e-vue-contextmenu>
  </div>
  <el-dialog :visible.sync="addGroupMsgShow" v-if="addGroupMsgShow" width="500px" :show-close="true" :close-on-click-modal="false" center class="all-open">
    <add-edit-group-msg v-model="addGroupMsgShow" :groupMsgObj="groupMsgObj" @getFamilyGroup="getFamilyGroup"></add-edit-group-msg>
  </el-dialog>
  <el-dialog top="7vh" :visible.sync="addGroupMemberShow" v-if="addGroupMemberShow" :width="widthOpen" :show-close="true" :close-on-click-modal="false" center class="all-open">
    <add-edit-group-member v-model="addGroupMemberShow" :groupMemberObj="groupMemberObj" @getFamilyMember="getFamilyMember"></add-edit-group-member>
  </el-dialog>
</div>
</template>

<script>
import {
  querymsggroup,
  deletemsggroup,
  querygroupmsg,
  addgroupmsg,
  querymsggroupmember,
  deletemsggroupmember
} from '../../api/device'
import addEditGroupMsg from './deviceComponents/addEditGroupMsg'
import addEditGroupMember from './deviceComponents/addEditGroupMember'
import BenzAMRRecorder from 'benz-amr-recorder'
export default {
  name: 'deviceGroupChat',
  components: {addEditGroupMsg, addEditGroupMember},
  data () {
    return {
      searchKeyword: '',
      sendWord: '',
      openData: '',
      msggroup: [],
      addGroupMsgShow: false,
      groupMsgObj: {
        isAdd: true,
        openTitle: '',
        groupMsgRow: ''
      },
      selectGroupMsg: '',
      isEdit: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      groupmsgs: [],
      amr: null,
      lastAudio: null,
      base: '',
      hasMore: true,
      // 成员
      openMember: '',
      msggroupmember: [],
      addGroupMemberShow: false,
      widthOpen: '900px',
      groupMemberObj: {
        isAdd: true,
        openTitle: '',
        selectGroupMsg: '',
        groupMemberRow: ''
      }
    }
  },
  created () {
    this.getGroupChatData()
    this.base = window.location.protocol + '//' + window.location.host
    if (window.location.host.split(':')[0] === 'localhost') {
      this.base = 'https://jiaold.com/'
    }
    // 群聊刷新
    this.golobleObject.mqttChat = this.getMattData
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    getGroupChatData () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: this.$store.state.user.orgid
      }
      querymsggroup(params, data).then(res => {
        this.msggroup = res.data.msggroup
        if (this.msggroup.length > 0) {
          if (this.selectGroupMsg === '') {
            this.selectGroupMsg = this.msggroup[0]
            this.groupMemberObj.selectGroupMsg = this.selectGroupMsg
            this.getGroupMsgData()
            this.getGroupMsgMember()
          } else {
            for (let i = 0; i < this.msggroup.length; i++) {
              if (this.isEdit && this.msggroup[i].id === this.selectGroupMsg.id) {
                this.selectGroupMsg = this.msggroup[i]
                this.groupMemberObj.selectGroupMsg = this.selectGroupMsg
              }
            }
          }
        }
      }).catch(() => {})
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      let data = this.msggroup
      let vm = this
      let search = data.filter((val) => {
        if (val.name.includes(vm.searchKeyword)) {
          return true
        }
      })
      return search
    },
    openAddEdit () {
      this.addGroupMsgShow = true
      this.groupMsgObj.isAdd = true
      this.groupMsgObj.openTitle = '新建群聊'
      this.groupMsgObj.groupMsgRow = ''
    },
    hideMenu () {
      this.$refs.ctxshow.hideMenu() // 隐藏菜单
      this.$refs.ctxshow1.hideMenu() // 隐藏菜单
    },
    show (data) {
      this.openData = data
      // console.log('菜单显示了', data)
    },
    hide (data) {
      this.openData = data
      // console.log('菜单隐藏了', data)
    },
    show1 (data) {
      this.openMember = data
      // console.log('菜单显示了', data)
    },
    hide1 (data) {
      this.openMember = data
      // console.log('菜单隐藏了', data)
    },
    updateGroupChat () {
      // 自定义事件
      this.addGroupMsgShow = true
      this.groupMsgObj.isAdd = false
      this.groupMsgObj.openTitle = '修改群聊'
      this.groupMsgObj.groupMsgRow = this.openData
    },
    editGroupMsg () {
      this.addGroupMsgShow = true
      this.groupMsgObj.isAdd = false
      this.groupMsgObj.openTitle = '修改群聊'
      this.groupMsgObj.groupMsgRow = this.selectGroupMsg
    },
    delGroupChat () {
      // 自定义事件
      let vm = this
      this.$confirm('此操作将永久删除该群聊【' + this.openData.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          msggroupid: [vm.openData.id]
        }
        deletemsggroup(data).then(res => {
          this.$notify({
            title: '成功',
            message: '成功删除群聊',
            type: 'success',
            duration: 2000
          })
          if (data.msggroupid[0] === this.selectGroupMsg.id) {
            this.selectGroupMsg = ''
            this.groupMemberObj.selectGroupMsg = this.selectGroupMsg
          }
          this.getGroupChatData()
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除群聊失败'
          })
        })
      }).catch(() => {})
    },
    getFamilyGroup (obj) {
      if (obj.id === this.selectGroupMsg.id) {
        this.isEdit = true
      } else {
        this.isEdit = false
      }
      this.getGroupChatData()
    },
    openChat (item) {
      // console.log(this.selectGroupMsg.id, item)
      this.pageSize = 10
      this.currentPage = 1
      this.totalCells = 0
      if (this.selectGroupMsg.id !== item.id) {
        this.groupmsgs = []
        this.selectGroupMsg = item
        this.groupMemberObj.selectGroupMsg = this.selectGroupMsg
        this.getGroupMsgData()
        this.getGroupMsgMember()
      } else {
        // 刷新
        this.getGroupMsgData()
      }
    },
    scrollInfo (e) {
      if (!this.$refs.msgBox.scrollTop) {
        if (!this.hasMore) {
          return
        }
        this.currentPage++
        console.log(111, this.currentPage)
        this.getGroupMsgData()
      }
    },
    scrollToEnd (el, el1) {
      // console.log(el1.offsetHeight)
      el.scrollTo(0, el1.offsetHeight)
    },
    // mqtt
    getMattData (obj) {
      // console.log('刷新', obj)
      this.openChat(this.selectGroupMsg)
    },
    // 获取群聊信息
    getGroupMsgData () {
      if (this.selectGroupMsg === '') {
        return
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        msggroupid: parseInt(this.selectGroupMsg.id)
      }
      querygroupmsg(params, data).then(res => {
        let arr = []
        for (let i = 0; i < res.data.groupmsgs.length; i++) {
          arr.unshift(res.data.groupmsgs[i])
        }
        // this.groupmsgs = res.data.groupmsgs
        if (this.currentPage === 1) {
          this.groupmsgs = arr
        } else {
          this.groupmsgs = arr.concat(this.groupmsgs)
        }
        if (res.data.cnt <= this.groupmsgs.length) {
          this.hasMore = false
        }
        this.groupmsgs.forEach(function (record) {
          if (record.msg_url.substring(record.msg_url.length - 3, record.msg_url.length) === 'amr') {
            record['isRecordType'] = 'amr'
          } else {
            record['isRecordType'] = 'mp3'
          }
          record['isRecord'] = false
          record['isGif'] = false
        })
        this.totalCells = res.data.cnt
        this.$nextTick(() => {
          if (this.currentPage === 1) {
            this.scrollToEnd(this.$refs.msgBox, this.$refs.msgData)
          }
        })
      }).catch(() => {})
    },
    playRecordItem (item, index, type) {
      // console.log(item, index, type)
      if (type === 'mp3') {
        if (this.amr !== null) {
          if (this.amr.isPlaying()) {
            this.amr.stop()
          }
          this.amr = null
          this.groupmsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }
        if (this.lastAudio) {
          this.lastAudio.pause()
          this.lastAudio.currentTime = 0
          this.groupmsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }
        this.groupmsgs[index].isGif = true
        this.$forceUpdate()
        this.lastAudio = this.$refs['mp3Item' + index][0]
        this.$refs['mp3Item' + index][0].play()
        let vm = this
        this.$refs['mp3Item' + index][0].addEventListener('ended', (e) => {
          vm.groupmsgs[index].isGif = false
          this.$forceUpdate()
        })
      } else { // arm
        if (!item.isRecord) {
          this.playRecord(item, index)
        } else {
          this.stopRecord(item, index)
        }
      }
    },
    playRecord (row, index) {
      let vm = this
      let flag = false
      if (row.msg_url.substring(row.msg_url.length - 3, row.msg_url.length) === 'amr') {
        flag = true
      }
      if (flag) {
        if (this.lastAudio) {
          this.lastAudio.pause()
          this.lastAudio.currentTime = 0
          this.groupmsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }
        if (vm.amr !== null) {
          if (vm.amr.isPlaying()) {
            vm.amr.stop()
          }
          vm.amr = null
          this.groupmsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }
        vm.amr = new BenzAMRRecorder()
        let url = this.base + row.msg_url
        // let url = "https://jiajiafile.jiajialife.com:20087/audio/353537067400568_1666087242.amr",
        vm.amr.initWithUrl(url).then(function () {
          vm.amr.play()
          vm.groupmsgs[index].isRecord = true
          vm.groupmsgs[index].isGif = true
          // vm.groupmsgs.forEach(function (record) {
          //   if (record.id !== row.id) {
          //     record.isRecord = true
          //     record.isGif = true
          //   }
          // })
          vm.$forceUpdate()
        })
        vm.amr.onEnded(function () {
          // row.isRecord = false
          vm.groupmsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          vm.$forceUpdate()
        })
      }
    },
    stopRecord (row, index) {
      if (this.amr !== null) {
        this.amr.stop()
        this.amr = null
        this.groupmsgs[index].isRecord = true
        this.groupmsgs[index].isGif = true
        // row.isRecord = false
        // this.groupmsgs.forEach(function (record) {
        //   record.isRecord = false
        //   record.isGif = false
        // })
        this.$forceUpdate()
      }
    },
    sendVoiceMsg () {
      if (this.sendWord !== '') {
        let data = {
          text: this.sendWord,
          msggroupid: this.selectGroupMsg.id
        }
        addgroupmsg(data).then(res => {
          this.pageSize = 10
          this.currentPage = 1
          this.getGroupMsgData()
          this.sendWord = ''
        }).catch(() => {})
      }
    },
    // 获取群聊成员
    getGroupMsgMember () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        msggroupid: parseInt(this.selectGroupMsg.id)
      }
      querymsggroupmember(params, data).then(res => {
        this.msggroupmember = res.data.msggroupmember
      }).catch(() => {})
    },
    addGroupMember () {
      if (this.tbdata.length === []) {
        this.$message({
          type: 'warning',
          message: '请先创建群组。'
        })
        return
      }
      this.widthOpen = '900px'
      this.addGroupMemberShow = true
      this.groupMemberObj.isAdd = true
      this.groupMemberObj.openTitle = '添加群聊成员'
      this.groupMemberObj.groupMemberRow = ''
    },
    updateGroupMember () {
      this.widthOpen = '500px'
      this.addGroupMemberShow = true
      this.groupMemberObj.isAdd = false
      this.groupMemberObj.openTitle = '修改群聊成员'
      this.groupMemberObj.groupMemberRow = this.openMember
    },
    delGroupMember () {
      console.log(this.openMember)
      let vm = this
      this.$confirm('此操作将永久删除该群聊【' + this.openMember.member_name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          msggroupid: vm.selectGroupMsg.id,
          msggroupmemberid: [vm.openMember.id],
          did: vm.openMember.did
        }
        deletemsggroupmember(data).then(res => {
          this.$notify({
            title: '成功',
            message: '成功删除成员',
            type: 'success',
            duration: 2000
          })
          this.getGroupMsgMember()
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除群聊失败'
          })
        })
      }).catch(() => {})
    },
    getFamilyMember () {
      this.getGroupMsgMember()
    }
  }
}
</script>

<style scoped>
.input{
  border: none;
  outline: none;
  height: 100%;
  font-size: 18px;
  background: none;
}
.left-list{
  width: 420px;
  background-color: #363e47;
  height: 100%;
  float: left;
}
.center-list{
  width: calc(100% - 781px);
  background-color: #f2f7f7;
  height: 100%;
  float: left;
}
.right-msg{
  border-left: 1px solid #e3e7e7;
  width: 360px;
  background-color: #ffffff;
  height: 100%;
  float: left;
}
.head-portrait-top{
  height: 170px;
  padding-top: 30px;
  text-align: center;
}
.search-top{
  height: 51px;
  padding-top: 15px;
  border-bottom: 2px solid #303841;
}
.rec-search {
  color: #a5b5c1;
  width: calc(100% - 86px);
  height: 36px;
  background-color: #303841;
  border-radius: 13px;
  margin: 0 15px;
  float: left;
  font-size: 18px;
}
.cir-btn-add {
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border-radius: 18px;
  background-color: #303841;
  float: left;
  color: #a5b5c1;
  cursor: pointer;
}
.contact-list{
  height: calc(100% - 70px);
  overflow-y: auto;
}
.list-item{
  padding: 10px 0;
  height: 60px;
  margin: 0 15px;
  border-bottom: 1px solid #525151;
}
.list-item1{
  padding: 10px 0;
  height: 60px;
  margin: 0 15px;
  border-bottom: 1px solid #cccccc;
}
.head-portrait{
  padding-top: 10px;
  float: left;
  height: 50px;
  width: 60px;
}
.msg-contact{
  color: #d6dce1;
  float: left;
  width: calc(100% - 150px);
  height: 60px;
}
.name-top{
  height: 40px;
  line-height: 50px;
  font-size: 18px;
  color: #d6dce1;
}
.voice-bottom{
  height: 20px;
  font-size: 12px;
}
.name-top1{
  height: 60px;
  line-height: 70px;
  font-size: 18px;
  color: #1a1a1a;
}
.msg-time{
  color: #808080;
  float: left;
  width: 90px;
  height: 60px;
  line-height: 60px;
  text-align: right;
}
.title-top{
  height: 51px;
  padding-top: 15px;
  border-bottom: 2px solid #e3e7e7;
}
.title-edit{
  float: left;
  margin-left: 20px;
  width: calc(100% - 80px);
  height: 36px;
  line-height: 36px;
  color: #303841;
  font-size: 20px;
  font-family: PingFang-SC-Medium!important;
}
.user-add-right{
  padding-top: 4px;
  width: 40px;
  height: 40px;
  float: right;
  margin-right: 20px;
  text-align: right;
}
.window-center{
  height: calc(100% - 158px);
  overflow-y: auto;
}
.time-show{
  color: #cccccc;
  height: 20px;
  line-height: 20px;
  width: 130px;
  border-radius: 4px;
  font-size: 10px;
  /*margin: auto;*/
  text-align: center;
}
.chat-item{
  height: 60px;
  margin: 0 20px;
}
.img-left{
  width: 60px;
  padding-top: 5px;
  height: 55px;
  float: left;
}
.img-left1{
  width: 60px;
  padding-top: 5px;
  height: 55px;
  float: right;
}
.voice-right{
  width: 160px;
  padding-top: 10px;
  height: 40px;
  float: left;
  /*background-color: #7ebbfc;*/
}
.voice-right1{
  width: 160px;
  padding-top: 10px;
  height: 40px;
  float: right;
  /*background-color: #7ebbfc;*/
}
.no-read{
  width: 10px;
  height: 10px;
  background-color: #f35d5d;
  border-radius: 5px;
  margin-top: 15px;
}
.left-voice-content{
  background-color: white;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  float: left;
}
.left-voice-content img{
  vertical-align: middle;
  margin-left: 10px;
}
.right-voice-content{
  background-color: #55d48b;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  text-align: right;
  float: right;
  margin-right: 10px;
}
.right-voice-content img{
  vertical-align: middle;
  margin-right: 10px;
}
.msg-send{
  height: 90px;
  background-color: white;
}
.area-text{
  margin-top: 25px;
  font-size: 18px;
  height: 40px;
  float: left;
  margin-left: 20px;
  width: calc(100% - 170px);
}
.send-btn-chat{
  margin-top: 25px;
  font-family: PingFang-SC-Medium!important;
  font-size: 20px;
  width: 130px;
  height: 40px;
  line-height: 40px;
  color: white;
  text-align: center;
  background-color: #55d48b;
  border-radius: 10px;
  float: right;
  margin-right: 20px;
  cursor: pointer;
}
.msg-list{
  height: 40px;
  font-size: 14px;
  color: #99a8b4;
}
.right-text{
  display: block;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceGroupChat.vue